class Calculations {
  bildStressProfilesForPoems(poems) {
    let numberLines = 0;
    let numberPoems = 0;
    let stressProfileAll = [];
    let occurenceAll = [];

    //array with summary stress profile for every poem
    let poemsProfiles = [];

    if (poems.length > 0) {
      for (let index = 0; index < poems.length; index++) {
        numberPoems++;
        let poemLines = poems[index].linesOfPoemList;

        let stressProfilePoem = [];
        let occurencePoem = [];
        for (let ind = 0; ind < poemLines.length; ind++) {
          numberLines++;
          let line = poemLines[ind].representation.trim();

//preparing
          //grow up length of arrays:
          if (line.length > stressProfilePoem.length) {
            while (line.length > stressProfilePoem.length) {
              stressProfilePoem.push(0);
              occurencePoem.push(0);
            }
          }
          if (line.length > stressProfileAll.length) {
            while (line.length > stressProfileAll.length) {
              stressProfileAll.push(0);
              occurenceAll.push(0);
            }
          }

          //loop by line and stresses
          let charArray = Array.from(line);
          for (let j = 0; j < charArray.length; j++) {
            if (charArray[j] === "1") {
              stressProfilePoem[j] = stressProfilePoem[j] + 1;
              stressProfileAll[j] = stressProfileAll[j] + 1;
            }
            occurencePoem[j] = occurencePoem[j] + 1;
            occurenceAll[j] = occurenceAll[j] + 1;
          }
        }

        //calculate stress profile for poem in %
        for (let j = 0; j < stressProfilePoem.length; j++) {
          stressProfilePoem[j] = Math.ceil(
            10*(100 * stressProfilePoem[j]) / occurencePoem[j]
          )/10;
        }

        //and at least push this stress profile to returning value
        poemsProfiles.push(stressProfilePoem);
      }
    }

    //stress profile for all poems:
    for (let j = 0; j < stressProfileAll.length; j++) {
      stressProfileAll[j] = Math.ceil(
        10* (100 * stressProfileAll[j]) / occurenceAll[j]
      )/10;
    }

    const returningMap = new Map();
    returningMap.set("numberLines", numberLines);
    returningMap.set("numberPoems", numberPoems);
    returningMap.set("poemsProfiles", poemsProfiles);
    returningMap.set("stressProfileAll", stressProfileAll);

    return returningMap;
  }

}

export default new Calculations();
